import React, { useState } from "react";
import { useSelector } from "react-redux";
import TextbausteinNew from "../../newForms2/textbausteine/TextbausteinNew";
import { textbausteinTypes1 } from "./textbausteinTypes";
import { Table } from "react-bootstrap";

const TextbausteinSubList = ({ type, setActiveTextbaustein }) => {
  const [showDetails, setShowDetails] = useState(false);

  const textbausteine = useSelector((st) => st.textbausteine);

  const filtered = textbausteine.filter((tb) => tb.type === type.type);
  // console.log({ filtered });

  const table = () => (
    <Table>
      <thead>
        <tr>
          <th>Punkte</th>
          <th>Nummer</th>

          <th>Text</th>
        </tr>
      </thead>
      <tbody>
        {filtered.map((f, idx) => {
          return (
            <>
            {(idx > 0 && filtered[idx - 1].punkte !== filtered[idx].punkte) ? <tr key = {`${f.id}__`} style={{borderTop:"3px solid grey"}}></tr>:null}
            <tr key={f.id} onClick={() => setActiveTextbaustein(f.id)}>
              <td>{f.punkte}</td>
              <td>{`Baustein ${f.number}`}</td>
              <td>{f.text}</td>
            </tr>
            </>
          );
        })}
      </tbody>
    </Table>
  );

  return (
    <div key={type.type}>
      <h4 onClick = {() => setShowDetails(!showDetails)}>{type.text} </h4>
      {showDetails && table()}
    </div>
  );
};
export default TextbausteinSubList;
